import { observable, action } from "mobx";

class Store {
  @observable open: boolean = false;
  @observable message: string = "";

  resetStore() {
    this.open = false;
    this.message = "";
  }

  @action OpenException(msg: string): void {
    console.log("msg: ", msg);
    this.message = msg;
    this.open = true;
  }

  @action CloseException(): void {
    this.message = "";
    this.open = false;
  }
}

let ExceptionStore = new Store();

export { ExceptionStore };



// WEBPACK FOOTER //
// ./src/common/exception/ExceptionStore.ts